import React from 'react'
import {Column, Row} from './Layout'

export const ProgressBars1 = ({progress, max}: {progress?: number | string; max: number}) => {
    const progressInt = typeof progress === 'string' ? parseInt(progress) || 0 : progress
    return (
        <Row height="6px" width="100%">
            {[1, 2, 3, 4, 5].slice(0, max).map((step) => (
                <Row key={step} grow={1} shrink={1}>
                    {step > 1 ? <Column grow={0} width="6px" /> : null}
                    <Column
                        grow={1}
                        backgroundColor={(progressInt || 1) >= step ? 'rgb(60, 142, 255)' : 'rgb(235, 235, 235)'}
                    />
                </Row>
            ))}
        </Row>
    )
}

export const ProgressBars2 = ({progress, total}: {progress?: number | string; total?: number | string}) => {
    const progressInt = (typeof progress === 'string' ? parseInt(progress) : progress) || 1
    const totalInt = (typeof total === 'string' ? parseInt(total) : total) || 4
    return (
        <Row>
            {totalInt > 1 && (
                <Column
                    width="16px"
                    height="16px"
                    borderRadius="8px"
                    backgroundColor={progressInt === 1 ? 'rgb(77, 77, 77)' : 'rgb(235, 235, 235)'}
                />
            )}
            {totalInt > 1 && <Column width="6px" />}
            {totalInt > 1 && (
                <Column
                    width="16px"
                    height="16px"
                    borderRadius="8px"
                    backgroundColor={progressInt === 2 ? 'rgb(77, 77, 77)' : 'rgb(235, 235, 235)'}
                />
            )}
            {totalInt > 2 && <Column width="6px" />}
            {totalInt > 2 && (
                <Column
                    width="16px"
                    height="16px"
                    borderRadius="8px"
                    backgroundColor={progressInt === 3 ? 'rgb(77, 77, 77)' : 'rgb(235, 235, 235)'}
                />
            )}
            {totalInt > 3 && <Column width="6px" />}
            {totalInt > 3 && (
                <Column
                    width="16px"
                    height="16px"
                    borderRadius="8px"
                    backgroundColor={progressInt === 4 ? 'rgb(77, 77, 77)' : 'rgb(235, 235, 235)'}
                />
            )}
            {totalInt > 4 && <Column width="6px" />}
            {totalInt > 4 && (
                <Column
                    width="16px"
                    height="16px"
                    borderRadius="8px"
                    backgroundColor={progressInt === 5 ? 'rgb(77, 77, 77)' : 'rgb(235, 235, 235)'}
                />
            )}
        </Row>
    )
}
